import {sendGetRequest, sendPostRequest} from '../requests';
import {ProcessType} from '../settings/alert_alarm';

const baseUrl = '/processes';

export const getProcesses = () =>
  sendGetRequest(baseUrl);

export const getRunningProcesses = (type: string, quickFilter: string) => {
  let resultFilter = '';

  if (type === ProcessType.SCHEDULING) {
    resultFilter = quickFilter && quickFilter !== 'ALL' ? quickFilter : '';
  }

  const query = resultFilter ? `?quick_filter=${resultFilter}` : '';

  return sendGetRequest(`${baseUrl}/type/${type}${query}`);
};

export const getProcessesByPatientId = (id: number) =>
  sendGetRequest(`${baseUrl}/patient/${id}`);

export const getAvailableProcesses = (type: string) =>
  sendGetRequest(`/nomenclature${baseUrl}/${type}/sub-processes`);

export const getAllProcessTypeDetails = () =>
  sendGetRequest(`/nomenclature${baseUrl}`);

export const getAvailableProcessAssigneeGroups = (type: string) =>
  sendGetRequest(`/nomenclature${baseUrl}/${type}/groups`);

export const startProcess = (type: string,
    body: {patientId: number, wantSooner: boolean}) =>
  sendPostRequest(`${baseUrl}/${type}/start`, body);

export const startSubProcess = (id: number | string,
    body: {processId: number | string, subProcessType: string}) =>
  sendPostRequest(`${baseUrl}/${id}/subprocess`, body);

export const getProcessDetailsById = (id: string) =>
  sendGetRequest(`${baseUrl}/${id}/details`);

export const getTasksDetailsByProcessId = (id: string) =>
  sendGetRequest(`${baseUrl}/${id}/tasks`);

export const claimProcess = (id: number) =>
  sendPostRequest(`${baseUrl}/${id}/claim`);

export const discardProcess = (id: number) =>
  sendPostRequest(`${baseUrl}/${id}/discard`);

export const reclaimProcess = (id: number, previousAssigneeId: number) =>
  sendPostRequest(`${baseUrl}/${id}/reassign?previous_assignee=${previousAssigneeId}`);

export const getCountOfProcessTasks = (id: number) =>
  sendGetRequest(`${baseUrl}/${id}/tasks/count`);
